<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <high-turnover-report-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import HighTurnoverReportTable from './HighTurnoverReportTable.vue'

  export default {
    name: 'highturnover-report',
    components: {HighTurnoverReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/risk/promotion/HighTurnoverReport.vue